var map = {
	"./ContactUsPage.tsx": 49341,
	"./CookiePolicyPage.tsx": 10722,
	"./DocumentationPage.tsx": 10835,
	"./LegalAccessibilityPage.tsx": 65783,
	"./OnboardingPage.tsx": 9051,
	"./PrivacyPolicyPage.tsx": 40212,
	"./ProductConfigPage.tsx": 13569,
	"./ProfilePage.tsx": 26485
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36496;